<template>
  <div class="category-form-container">
    <v-dialog v-model="dialog" max-width="500px" @click:outside="clearData">
      <template v-slot:activator="{ attrs }">
        <v-btn color="success" class="mb-2" v-bind="attrs" @click="toggleDialog"
          >+ เพิ่มหมวดหมู่</v-btn
        >
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">{{ modalTitle }}หมวดหมู่</span>
        </v-card-title>

        <v-card-text class="modal-card-text">
          <v-container>
            <v-form ref="form">
              <v-text-field
                v-model="formData.code"
                label="รหัสหมวดหมู่*"
                outlined
                dense
                :rules="[rules.required]"
              />
              <v-text-field
                v-model="formData.name"
                label="ชื่อหมวดหมู่*"
                outlined
                dense
                :rules="[rules.required]"
              />
            </v-form>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="clearData">ปิดหน้าต่าง</v-btn>
          <v-btn color="success" @click="submitForm" :disabled="validate"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep, findIndex, isEmpty, get } from "lodash";
import Utils from "@/mixin";

export default {
  computed: {
    validate() {
      const { name, code } = this.formData;
      if (
        (this.editId === "" && (isEmpty(name) || isEmpty(code))) ||
        (this.editId !== "" && (isEmpty(name) || isEmpty(code)))
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  data: () => ({
    modalTitle: "เพิ่ม",
    initialForm: {
      name: "",
      code: "",
    },
    formData: {
      name: "",
      code: "",
    },
    rules: {
      required: (value) => !!value || "กรุณากรอกข้อมูล",
    },
  }),
  methods: {
    clearData() {
      if (this.$props.editId !== "") this.$props.setInitialDialog();
      this.toggleDialog();
      this.$nextTick(() => {
        this.modalTitle = "เพิ่ม";
        const cloneInit = cloneDeep(this.initialForm);
        this.formData = Object.assign({}, cloneInit);
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    submitForm() {
      const { formData } = this;
      if (this.$props.editId !== "") {
        const submitForm = {
          name: get(formData, "name"),
          code: get(formData, "code"),
          id: this.$props.editId,
        };
        this.editCategory(submitForm);
      } else {
        const submitForm = {
          name: get(formData, "name"),
          code: get(formData, "code"),
        };
        this.createCategory(submitForm);
      }
      this.clearData();
    },
  },
  mixins: [Utils],
  props: {
    editId: {
      type: [Number, String],
      default: "",
    },
    dialog: {
      type: Boolean,
      default: false,
    },
    toggleDialog: {
      type: Function,
      default: () => {},
    },
    setInitialDialog: {
      type: Function,
      default: () => {},
    },
  },
  watch: {
    editId(nextProps, prevProps) {
      if (prevProps !== nextProps && nextProps !== "") {
        this.modalTitle = "แก้ไข";
        const categories = this.categories?.data || [];
        const index = findIndex(categories, (i) => i.id === this.editId);

        if (index !== -1) {
          const data = categories[index];
          this.formData = {
            name: data.name,
            code: data.code,
          };
        }
      }
    },
  },
};
</script>